import React from 'react'
import TextField from '../Reusable/Form/TextInput'

const RoleForm = (props: any) => {
  const { userPermissions, selectedUserPermissions, register, errors, setSelectedPermission } = props

  const handleCheckUnchecedPermission = (codeName: string) => {
    const index = selectedUserPermissions.indexOf(codeName);
    if (index === -1) {
      // Element not found, so append it
      selectedUserPermissions.push(codeName);
    } else {
      // Element found, so delete it
      selectedUserPermissions.splice(index, 1);
    }
    setSelectedPermission([...selectedUserPermissions])
  }

  const checkIsSelected = (codeName: string) => {
    const index = selectedUserPermissions.indexOf(codeName);
    if (index === -1) {
      return false
    } return true
  }
  return (
    <>
      <TextField
        label={"Name"}
        register={register("role")}
        errors={errors?.role}
      />
      <h2 className='uppercase font-bold text-gray-400 mt-6'>User Management</h2>
      <div className='h-[1px] w-full bg-gray-400 rounded' />
      <div className="grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 sm:grid-rows-1 gap-x-3  gap-y-10">
        {userPermissions && Object.keys(userPermissions)?.map((key: string, index: number) => (
          <div className="my-6" key={index}>
            <div className="py-5 shadow-md p-6">
              <details className="group">
                <summary className="flex justify-between items-center font-medium cursor-pointer list-none">
                  <span className='uppercase font-bold text-gray-400 '>{key}</span>
                  <span className="transition group-open:rotate-180">
                    <svg fill="none" height="24" shapeRendering="geometricPrecision" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" width="24"><path d="M6 9l6 6 6-6"></path>
                    </svg>
                  </span>
                </summary>
                <div className='py-6'>
                  {userPermissions[key]?.map((item: any, index: number) => (
                    <div key={index} className='flex justify-between items-center gap-6'>
                      <label htmlFor={item?.codeName} className='cursor-pointer capitalize'>{item?.name}</label>
                      <input type="checkbox" checked={checkIsSelected(item?.codeName)} onChange={() => handleCheckUnchecedPermission(item?.codeName)} className="appearance-none w-4 h-4 border-[1px] border-gray-500 mt-1 shrink-0 checked:bg-primary checked:border-0 mr-2 cursor-pointer" id={item?.codeName} />
                    </div>
                  ))}
                </div>
              </details>
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

export default RoleForm